import React, { createContext, useState, useMemo } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [mode, setMode] = useState(() => {
        return localStorage.getItem('ovpn_theme') || 'dark';
    });
    
    const [lang, setLang] = useState(() => {
        return localStorage.getItem('ovpn_lang') || 'uk';
    });

    const toggleTheme = () => {
        setMode((prev) => {
            const newMode = prev === 'light' ? 'dark' : 'light';
            localStorage.setItem('ovpn_theme', newMode);
            return newMode;
        });
    };

    const toggleLang = () => {
        setLang((prev) => {
            const newLang = prev === 'uk' ? 'en' : 'uk';
            localStorage.setItem('ovpn_lang', newLang);
            return newLang;
        });
    };

    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode,
                    primary: {
                        main: mode === 'dark' ? '#38bdf8' : '#0ea5e9', // Cyan/Electric Blue
                    },
                    background: {
                        default: mode === 'dark' ? '#060d18' : '#f0f4f8',
                        paper: mode === 'dark' ? '#0D1B2A' : '#ffffff',
                    },
                    text: {
                        primary: mode === 'dark' ? '#f1f5f9' : '#0f172a',
                        secondary: mode === 'dark' ? '#94a3b8' : '#475569',
                    }
                },
                typography: {
                    fontFamily: '"Inter", "Montserrat", "Roboto", "Helvetica", "Arial", sans-serif',
                },
                components: {
                    MuiCard: {
                        styleOverrides: {
                            root: {
                                borderRadius: 12,
                                backgroundImage: 'none',
                                borderColor: mode === 'dark' ? '#1e293b' : '#e2e8f0',
                            }
                        }
                    },
                    MuiButton: {
                        styleOverrides: {
                            root: {
                                borderRadius: 8,
                                textTransform: 'none',
                                fontWeight: 600,
                            }
                        }
                    }
                }
            }),
        [mode]
    );

    return (
        <AppContext.Provider value={{ mode, toggleTheme, lang, toggleLang }}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </AppContext.Provider>
    );
};
